import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

const ConfirmEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const hasVerified = useRef(false);

  useEffect(() => {
    if (hasVerified.current) return;
    hasVerified.current = true;

    const params = new URLSearchParams(location.search);
    const token_hash = params.get("token_hash");
    const type = params.get("type") || "email";

    if (!token_hash || !type) {
      navigate(`/auth/error?error=Missing+token_hash+or+type`);
      return;
    }

    const verify = async () => {
      const { error } = await supabase.auth.verifyOtp({ token_hash, type });

      if (error) {
        setStatus("error");
        navigate(`/auth/error?error=${encodeURIComponent(error.message)}`);
        return;
      }

      const {
        data: { session },
        error: sessionError,
      } = await supabase.auth.getSession();

      if (sessionError || !session) {
        setStatus("error");
        navigate(
          `/auth/error?error=${encodeURIComponent(
            sessionError?.message || "No session found"
          )}`
        );
        return;
      }

      localStorage.setItem("token", session.access_token);
      setStatus("success");
      navigate("/users");
    };

    verify();
  }, [location.search, navigate]);

  return (
    <div style={{ padding: "1rem", textAlign: "center" }}>
      {status === "verifying" && <p>Verifying your email...</p>}
      {status === "error" && <p>Verification failed. Redirecting...</p>}
    </div>
  );
};

export default ConfirmEmail;
